import DNI3Card from './DNI3Card';

export default DNI3Card;
